/* tslint:disable */

/**
 */
export class Consumptions {
    ID_CONSUMPTIONS?: number;
    ID_EQUIP?: number;
    TEMPERATURE?: number;
    CONSUMPTION_PERM?: number;
    CONSUMPTION_GETCOLD?: number;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/consumptions.ts